// extracted by mini-css-extract-plugin
export default {"Shelf":"hoLZqezZ","Spacer":"ax1LBm0p","ShelfContainer":"aRVtYipt"};